module.exports = {
  src: __webpack_public_path__ + "logo-capital-fr-horizontal-9645ac374bb1151b4bde86391690ff5a.png",
  width: 249,
  height: 92,
  bytes: 22237,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-capital-fr-horizontal-9645ac374bb1151b4bde86391690ff5a.png";
};